<template>
	<div>
		<div class="bs-example form-group dispatch-active active">
			<row style="display: flex; flex-wrap: wrap;width: 100%;">
				<a-col class="form-item">
					<span class="label">{{ $t('businessDispatch.billNumber') }}</span>
					<div class="item-content">
						<a-auto-complete v-model.trim="req.params.condition.blNumber" style="width: 100%;"
							:data-source="dataSourceblNumber" size="small"
							:placeholder="$t('businessDispatch.billNumber')" :allowClear="true" @select="onSelect"
							@change="onChangeinput" class="input-area" />
					</div>
				</a-col>
				<a-col class="form-item">
					<span class="label">{{ $t('businessDispatch.plateNumber') }}</span>
					<div class="item-content">
						<a-input v-model.trim="req.params.condition.truck" size="small"
							:placeholder="$t('businessDispatch.plateNumber')" :allowClear="true" class="input-area" />
					</div>
				</a-col>
				<a-col class="form-item">
					<span class="label">{{ $t('businessDispatch.businessNumber') }}</span>
					<div class="item-content">
						<a-input v-model.trim="req.params.condition.orderNumber" size="small"
							:placeholder="$t('businessDispatch.businessNumber')" :allowClear="true"
							class="input-area" />
					</div>
				</a-col>
				<a-col class="form-item">
					<span class="label">{{ $t('businessDispatch.boxTime') }}</span>
					<div class="item-content">
						<a-range-picker :locale="locale" :ranges="{
							[$t('tomorrow')]: [moment(), moment()],
							[$t('currentMonth')]: [moment(), moment().endOf('month')],
						}" @change="onChange" v-model="dateRange" :valueFormat="dateFormat" :format="monthFormat"
							dropdownClassName="dateRangeClass" :getCalendarContainer="(triggerNode) => triggerNode.parentNode
								" size="small" class="range-picker" />
					</div>
				</a-col>
				<a-col class="form-item" style="padding-left: 10px;">
					<div class="special-wrap input-form">
						<template v-for="(item, index) in directTimelist">
							<span :class="activeItem == item.name ? 'main-div isActive' : 'main-div'
								" :key="index" @click="activeBtn(item)">
								{{ item.title }}
							</span>
						</template>
					</div>
				</a-col>
				<a-col class="form-item">
					<span class="label">{{ $t('businessDispatch.customerName') }}</span>
					<div class="item-content">
						<a-auto-complete v-model.trim="req.params.condition.customerName" style="width: 100%;"
							:data-source="searchNameList" size="small"
							:placeholder="$t('businessDispatch.customerName')" :allowClear="true" @select="onSelect"
							@change="onChangeinput" class="input-area" />
					</div>
				</a-col>
				<a-col class="form-item">
					<span class="label">{{ $t('businessDispatch.containerNumber') }}</span>
					<div class="item-content">
						<a-input v-model.trim="req.params.condition.containerNumber" size="small"
							:placeholder="$t('businessDispatch.containerNumber')" :allowClear="true"
							class="input-area" />
					</div>
				</a-col>
				<a-col class="form-item">
					<span class="label">{{ $t('businessDispatch.portArea') }}</span>
					<div class="item-content">
						<a-input v-model.trim="req.params.condition.portDistrict" size="small"
							:placeholder="$t('businessDispatch.portArea')" :allowClear="true" class="input-area" />
					</div>
				</a-col>
				<a-col class="form-item">
					<span class="label">{{ $t('businessDispatch.yard') }}</span>
					<div class="item-content">
						<a-input v-model.trim="req.params.condition.depot" size="small"
							:placeholder="$t('businessDispatch.yard')" :allowClear="true" class="input-area" />
					</div>
				</a-col>
				<a-col class="form-item">
					<span class="label">{{ $t('businessDispatch.importExport') }}</span>
					<div class="item-content">
						<a-select style="width:100%" :placeholder="$t('businessDispatch.importExport')"
							v-model.trim="req.params.condition.boundType"
							:getPopupContainer="(triggerNode) => triggerNode.parentNode" :allowClear="true" size="small"
							class="select-area">
							<a-select-option value="IB">
								{{ $t('import') }}
							</a-select-option>
							<a-select-option value="OB">
								{{ $t('export') }}
							</a-select-option>
						</a-select>
					</div>
				</a-col>
				<a-col class="form-item">
					<span class="label">{{ $t('businessDispatch.orderStatus') }}</span>
					<div class="item-content">
						<a-select mode="multiple" :maxTagCount="1" :maxTagPlaceholder="'+' +
							(req.params.condition.orderStatusList
								? req.params.condition.orderStatusList.length - 1
								: '')
							" style="width:100%" :placeholder="$t('businessDispatch.orderStatus')"
							v-model.trim="req.params.condition.orderStatusList"
							:getPopupContainer="(triggerNode) => triggerNode.parentNode" :allowClear="true" size="small"
							class="select-area multi-select" @change="changeOrderStatus">
							<template v-for="(item, index) in orderStatusSelect">
								<a-select-option :value="item.value" :key="index">
									{{ item.label }}
								</a-select-option>
							</template>
						</a-select>
					</div>
				</a-col>
				<a-col class="form-item">
					<span class="label">{{ $t('businessDispatch.transportStatus') }}</span>
					<div class="item-content">
						<a-select style="width:100%" :placeholder="$t('businessDispatch.transportStatus')"
							v-model.trim="req.params.condition.trackStatus"
							:getPopupContainer="(triggerNode) => triggerNode.parentNode" :allowClear="true" size="small"
							class="select-area multi-select" @change="changeTransStatus">
							<!-- mode="multiple"
							:maxTagCount="1"
							:maxTagPlaceholder="'+' + (transStatus.length - 1)" 
							@change="changeTransStatus" -->
							<template v-for="(item, index) in trackStatusSelect">
								<a-select-option :value="item.value" :key="index">
									{{ item.label }}
								</a-select-option>
							</template>
						</a-select>
					</div>
				</a-col>
				<a-col class="form-item">
					<span class="label">{{ $t('businessDispatch.keyOrder') }}</span>
					<div class="item-content">
						<a-select :placeholder="$t('businessDispatch.keyOrder')"
							v-model.trim="req.params.condition.isImportantContainer"
							:getPopupContainer="(triggerNode) => triggerNode.parentNode" :allowClear="true" size="small"
							style="width: 100%;">
							<template v-for="(item, index) in importantContainerReasonSelect">
								<a-select-option :value="item.value" :key="index">
									{{ item.label }}
								</a-select-option>
							</template>
						</a-select>
					</div>

				</a-col>


				<a-col class="form-item">
					<span class="label">{{ $t('businessDispatch.businessNo') }}</span>
					<div class="item-content">
						<a-input v-model.trim="req.params.condition.businessNo" size="small"
							:placeholder="$t('businessDispatch.businessNo')" :allowClear="true" class="input-area" />
					</div>
				</a-col>
				<a-col class="form-item">
					<span class="label">{{$t('businessDispatch.temporaryStorageYard')}}</span>
					<div class="item-content">
						<a-input v-model.trim="req.params.condition.dropDepot" size="small"
							:placeholder="$t('businessDispatch.temporaryStorageYard')" :allowClear="true" class="input-area" />
					</div>
				</a-col>
				<a-col :span="24" class="form-item" style="display: flex;justify-content: right; width:100%">
					<a-button class="btn btn-info btn-sm" style="margin-right: 10px;" type="primary" size="small"
						@click="search">
						{{ $t('search') }}
					</a-button>
					<a-button class="btn btn-default" size="small" @click="reset">{{ $t('reset') }}</a-button>
				</a-col>
			</row>
		</div>
	</div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import dayjs from "dayjs";
import { orderStatusSelect, trackStatusSelect, importantContainerReasonSelect } from "./business-dispatch";
import { orderlist } from "../../api/business-dispatch";
import { searchReqParam } from "../../utils/searchReqParam";
import i18n from '@/locales/i18n'

const directTimelist = [
	{
		title: i18n.t('yesterday'),
		name: "yesterday",
		time: dayjs()
			.subtract(1, "day").format('YYYY-MM-DD')
	},
	{
		title: i18n.t('today'),
		name: "today",
		time: dayjs().format('YYYY-MM-DD')
	},
	{
		title: i18n.t('tomorrow'),
		name: "tomorrow",
		time: dayjs()
			.add(1, "day").format('YYYY-MM-DD')
	},
	{
		title: i18n.t('dayAfterTomorrow'),
		name: "afterday",
		time: dayjs()
			.add(2, "day").format('YYYY-MM-DD')
	},
	{ title: i18n.t('noBoxTime'), name: "notime", time: "" },
];
export default {
	name: "searchform",
	data() {
		return {
			req: {
				params: {
					condition: {
						businessNo: "", //业务箱编号
						blNumber: "", //	提单号
						truck: "", // 车牌号
						orderNumber: "", //  订单号
						customerName: "", // 客户名称
						planArrivalTimeStart: "", // 做箱时间(起)
						planArrivalTimeEnd: "", // 做箱时间(止)
						containerNumber: "", // 箱号
						portDistrict: undefined, // 港区
						depot: "", // 堆场
						boundType: undefined, // 进出口类型
						companyId: "", // 公司ID
						port: "",
						orderStatusList: [], // 订单状态
						trackStatus: undefined, // 运输状态
						isImportantContainer: "", // 重点跟单

					},
					page: 1, // 页码
					pageSize: 10, // 页容量
				},
			},
			orderStatusSelect,
			trackStatusSelect,
			importantContainerReasonSelect,
			dateRange: [],
			locale,
			dateFormat: "YYYY-MM-DD",
			monthFormat: "YYYY-MM-DD",
			show: true,
			directTimelist,
			// 点击的日期按钮
			activeItem: "",
			searchFormList: searchReqParam(),
			dataSourceblNumber: [],
			searchNameList: [],
		};
	},
	watch: {
		dateRange: {
			handler() {
				let params = this.req.params.condition;
				// console.log(this.dateRange,'this.dateRange')
				if (this.dateRange && this.dateRange.length == 2) {
					params.planArrivalTimeStart = this.dateRange[0]
						? this.dateRange[0] + " 00:00:00"
						: "";
					params.planArrivalTimeEnd = this.dateRange[1]
						? this.dateRange[1] + " 23:59:59"
						: "";
				} else {
					params.planArrivalTimeStart = "";
					params.planArrivalTimeEnd = "";
				}
			},
			deep: true,
		},
	},
	created() { },
	mounted() { },
	methods: {
		moment,
		// 监听日期筛选器的变动
		onChange() {
			console.log("== date change ==");
			this.activeItem = "";
		},
		handleChange(value) {
			console.log(`selected ${value}`);
		},
		search() {
			this.$emit("search", this.req);
		},
		getStyle(item) {
			if (item.isActive) {
				return { "background-color": "green" };
			}
			return {};
		},
		activeBtn(item) {
			// 如果点击不同的按钮
			if (this.activeItem != item.name) {
				// 给日期筛选器赋值
				this.dateRange = [item.time, item.time];
				console.log(this.dateRange);
				// 改变点击按钮的样式
				this.activeItem = item.name;
				console.log(this.activeItem);
				this.show = true;
				if (item.title == "无做箱时间" || item.title == 'No Packing Date' || item.title == 'Không có') {
					this.show = false;
				}
			} else {
				// 点击相同的按钮，取消选中
				this.dateRange = [null, null];
				this.activeItem = "";
				this.show = true;
			}
		},
		reset() {
			this.req.params.condition = {};
			this.dateRange = [];
			this.activeItem = "";
			this.show = true;
		},
		onSelect(value) {
			console.log("onSelect", value);
		},
		//  多选订单状态
		changeOrderStatus(value) {
			this.req.params.condition.orderStatusList = value;
			console.log(this.req.params.condition);
		},
		//  多选订单状态
		changeTransStatus(value) {
			console.log(`selected ${value}`);
			this.req.params.condition.trackStatus = value;
			console.log(this.req.params.condition);
		},
		onChangeinput(searchText) {
			console.log("onChangeinput", searchText, this.req);
			this.searchFormList.params = this.req.params;

			orderlist(this.searchFormList).then((res) => {
				let temp = JSON.parse(res.data).data.list;
				// 提单
				this.dataSourceblNumber = [];
				temp.map((item) => {
					if (this.dataSourceblNumber.indexOf(item.blNumber) == -1) {
						this.dataSourceblNumber.push(item.blNumber);
					}
					return this.dataSourceblNumber;
				});
				this.dataSourceblNumber = !searchText ? [] : this.dataSourceblNumber;
				// 客户名称
				this.searchNameList = [];
				temp.map((item) => {
					if (this.searchNameList.indexOf(item.customerName) == -1) {
						this.searchNameList.push(item.customerName);
					}
					return this.searchNameList;
				});
				this.searchNameList = !searchText ? [] : this.searchNameList;
			});
		},
	},
};
</script>
<style lang="less" scoped>
// .bs-example {
// 	width: 100%;
// 	min-height: 80px;
// }

// .breadcrumb {
// 	top: 0;
// 	left: 0;
// 	height: 50px;
// 	text-align: left;
// }

// .lineone {
// 	position: relative;
// 	width: 100%;
// }

// .linetwo {
// 	position: relative;
// 	width: 100%;
// }

// .input-form {
// 	position: relative;
// 	width: 17%;
// 	float: left;
// }

// .lineone .orderNumber {
// 	width: 17%;
// }

// .bs-example .input-form .ant-input {
// 	width: 150px;
// 	margin: 0 8px 8px 0;
// }

.form-item {
	position: relative;
	display: flex;
	align-items: center;
	margin-bottom: 8px;
	width: 20%;

	.item-content {
		position: relative;
		width: 60%;
	}
}

.label {
	width: 40%;
	display: inline-block;

}

// .bs-example .input-form .label {
// 	float: left;
// 	text-align: right;
// 	height: 28px;
// 	line-height: 28px;
// 	width: 80px;
// }

// .input-area {
// 	width: 60%;
// }

// .datewrap {
// 	width: 47%;
// }

// .timepicker {
// 	width: 60%;
// }

.special-wrap {
	width: 100%;
	// margin-left: 2%;
}

.special-wrap span {
	// padding-left: 10px;
	// width: 45px;
	display: block;
	float: left;
	// border: 1px solid;
	border-radius: 3px;
	text-align: center;
	// line-height: 27px;
	font-weight: bold;
	cursor: pointer;
	color: #fff;
	background-color: rgb(146, 139, 139);
	font-size: 12px;
	padding: 1px 1px;
	margin-right: 5px;
	margin-bottom: 5px;
}

// .bs-example .input-form .ant-calendar-picker {
// 	width: 190px;
// }

// .range-picker {
// 	display: block;
// 	float: left;
// 	margin-left: 4%;
// }

// .select-area {
// 	float: left;
// 	margin-left: 7%;
// }

// .pull-right {
// 	float: right;
// 	margin-right: 10px;
// }

// .bs-example .lineone .datepick {
// 	// width: 300px;
// 	width: 24%;
// }

// // 点击按钮的样式
.isActive {
	background-color: green !important;
}

// /deep/.multi-select .ant-select-selection__choice {
// 	position: absolute !important;
// 	min-width: 80px;
// 	// text-align: center;
// }

// /deep/.multi-select .ant-select-selection--multiple .ant-select-selection__choice__disabled {
// 	margin-left: 80px;
// 	min-width: 40px !important;
// }</style>
